// @flow
/* eslint-disable @gandi/gandi/no-global-element */

import * as React from 'react';

import type { FormApi } from 'final-form';
import arrayMutators from 'final-form-arrays';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { getCart, addDiscount } from '@gandi/cart';
// TODO: Export CartAPIResponse in @gandi/cart'
// import type { CartAPIResponse } from '@gandi/cart';

import { Form } from '@gandi/form/FinalForm';
import { useTranslator } from '@gandi/translate';
import { Button, SrOnly } from '@gandi/ui';

import { DiscountInput } from './DiscountInput';

import styles from './AddDiscount.scss';

type FormValues = {
  'discount-code'?: string,
};

const getMaybeApiError = (error: any, defaultMessage: string) => {
  return (
    (error.response?.data?.errors || [])[0]?.description ||
    error.response?.data?.message ||
    error.message ||
    defaultMessage
  );
};

function isUnusedDiscount(
  discount: number,
  unusedDiscounts: Array<{ id: number, label: string }>,
) {
  return (
    unusedDiscounts &&
    unusedDiscounts.some(unusedDiscount => unusedDiscount.id === discount)
  );
}

type Props = {
  success: ?string,
  setSuccess: React.ReactSetStateFunction<?string>,
};
function AddDiscount({
  success,
  setSuccess,
}: Props): React.MixedElement | null {
  const dispatch = useDispatch();
  const { __ } = useTranslator();
  const location = useLocation();

  const overviewPage = location.pathname.includes('overview');

  const [loading, setLoading] = React.useState(false);

  async function handleSubmit(
    formData: FormValues,
    form: FormApi<FormValues>,
  ): Promise<void | FormValues> | void {
    const value = formData['discount-code'];
    let promoId;
    if (!value) return;
    setLoading(true);
    try {
      // $FlowFixMe[incompatible-call] Change in the cart lib and add type
      await dispatch(addDiscount(value)).then(
        (resp: { data: { id: number, message: 'Resource Created' } }) => {
          promoId = resp?.data.id;
        },
      );

      // $FlowFixMe[incompatible-call] TODO: export CartAPIResponse type of the cart lib
      dispatch(getCart()).then(
        (resp: {
          data: {
            unused_discounts?: Array<{
              id: number,
              label: string,
            }>,
          },
        }) => {
          const unDiscount =
            resp.data.unused_discounts &&
            isUnusedDiscount(promoId, resp.data.unused_discounts);
          setSuccess(unDiscount ? undefined : value);
        },
      );
      form.reset();
    } catch (err) {
      const description = getMaybeApiError(
        err,
        __('Sorry, this code is no longer valid.'),
      );
      // eslint-disable-next-line consistent-return
      return {
        'discount-code': description,
      };
    } finally {
      setLoading(false);
    }
  }

  function handleClearHelp() {
    setSuccess();
  }

  if (!overviewPage) return null;

  return (
    <Form
      onSubmit={handleSubmit}
      mutators={arrayMutators}
      className={styles.container}
    >
      <SrOnly>
        {/* eslint-disable-next-line jsx-a11y/label-has-for */}
        <label htmlFor="discount-code">{__('Enter promo code here')}</label>
      </SrOnly>
      <DiscountInput success={success} handleClear={handleClearHelp} />

      <Button loading={loading} type="submit" className={styles.button}>
        {__('Submit')}
      </Button>
    </Form>
  );
}

export default AddDiscount;
